import type { ScrollHashItem, ScrollSection } from "../types";

export function buildSectionTargetId(
  item: ScrollHashItem,
  idPrefix: string,
): string {
  return idPrefix ? `${idPrefix}-${item.id}` : String(item.id);
}

export function mapItemToSection(
  item: ScrollHashItem,
  idPrefix: string,
  getElementById: (
    id: string,
  ) => HTMLElement | null = document.getElementById.bind(document),
): ScrollSection | null {
  const targetId = buildSectionTargetId(item, idPrefix);
  const element = getElementById(targetId);
  if (element) {
    const rect = element.getBoundingClientRect();
    return {
      id: item.id,
      targetId,
      top: rect.top,
      bottom: rect.bottom,
    };
  }
  return null;
}

export function collectSections(
  items: ScrollHashItem[],
  idPrefix: string,
  getElementById: (
    id: string,
  ) => HTMLElement | null = document.getElementById.bind(document),
): ScrollSection[] {
  return items
    .map((item) => mapItemToSection(item, idPrefix, getElementById))
    .filter((section): section is ScrollSection => section !== null);
}

export function pickActiveSection(
  sections: ScrollSection[],
  scrollY: number,
  viewportHeight: number,
): ScrollSection | null {
  const threshold = viewportHeight * 0.35;
  const bottomThreshold = 42;
  let activeSection: ScrollSection | null = null;

  for (const section of sections) {
    if (section.top <= threshold && section.bottom > bottomThreshold) {
      activeSection = section;
    }
  }

  if (!activeSection && sections.length > 0) {
    if (scrollY < 100) {
      activeSection = sections[0];
    } else {
      for (let i = sections.length - 1; i >= 0; i--) {
        if (sections[i].top < viewportHeight) {
          activeSection = sections[i];
          break;
        }
      }
    }
  }

  return activeSection;
}

export function findMatchingItem(
  items: ScrollHashItem[],
  param: string,
  idPrefix: string,
): ScrollHashItem | undefined {
  return items.find((item) => buildSectionTargetId(item, idPrefix) === param);
}

export function shouldEnableScrollSpyOnMount(
  hash: string,
  itemsLength: number,
): boolean {
  return !hash && itemsLength > 0;
}

export function shouldScheduleScrollDetection(ticking: boolean): boolean {
  return !ticking;
}
